import React from "react";
import "./ourservices.css";
import ImgB from "../../../Assets/Images/fr_bg.png";
import IC from "../../../Assets/Images/round1.png";
import FD from "../../../Assets/Images/round2.png";
import SC from "../../../Assets/Images/round3.png";
import SP from "../../../Assets/Images/round4.png";
import ASP from "../../../Assets/Images/round5.png";
import FP from "../../../Assets/Images/round6.png";
import ICSM from "../../../Assets/Images/instrcutional-classes-mobile.png";
import FDSM from "../../../Assets/Images/field-days-mobile-home.png";
import SCSM from "../../../Assets/Images/summer-camp-mobile-home.png";
import SPSM from "../../../Assets/Images/school-program-mobile-home.png";
import ASPSM from "../../../Assets/Images/after-school-mobile-home.png";
import FPSM from "../../../Assets/Images/fund-rising-mobile-home.png";
import CheckIcon from "../../../Assets/Icons/CheckIcon";
import { Link } from "react-router-dom";
import ArrowIcon from "../../../Assets/Icons/ArrowIcon";

const OurServices = () => {
  return (
    <div className="our-services-ui">
      <h2 className="black-text-clip">Our Services</h2>
      <div className="services-list">
        <div className="service-cards">
          <Link to="/instruction" className="sc sc1">
            <div className="sc-icon IC">
              <img src={IC} alt="icon" />
            </div>
          </Link>
          <Link to="/field-days" className="sc sc2">
            <div className="sc-icon FD">
              <img src={FD} alt="icon" />
            </div>
          </Link>
          <Link to="https://summercamp.bwcsports.com/" className="sc sc3">
            <div className="sc-icon SC">
              <img src={SC} alt="icon" />
            </div>
          </Link>
          <Link to="/school-programs" className="sc sc4">
            <div className="sc-icon SP">
              <img src={SP} alt="icon" />
            </div>
          </Link>
          <Link to="/after-school-programs" className="sc sc5">
            <div className="sc-icon ASP">
              <img src={ASP} alt="icon" />
            </div>
          </Link>
          <Link to="/fundraising" className="sc sc6">
            <div className="sc-icon FP">
              <img src={FP} alt="icon" />
            </div>
          </Link>
          {/* <div className="b-img">
            <img src={ImgB} alt="background" />
          </div> */}
        </div>
        <div className="img-b-sm">
          <img src={ImgB} alt="background" />
        </div>
        <div className="offer-sec">
          <h2 className="black-text-clip">WHAT WE OFFER</h2>
          <div className="offer-list">
            <ul>
              <li className="offer-items">
                <div className="offer-icon">
                  <CheckIcon />
                </div>
                <p>Quality Sports Services</p>
              </li>
              <li className="offer-items">
                <div className="offer-icon">
                  <CheckIcon />
                </div>
                <p>Multi Sports and Instruction</p>
              </li>
              <li className="offer-items">
                <div className="offer-icon">
                  <CheckIcon />
                </div>
                <p>Judgement Free</p>
              </li>
              <li className="offer-items">
                <div className="offer-icon">
                  <CheckIcon />
                </div>
                <p>DOE Vendor</p>
              </li>
              <li className="offer-items">
                <div className="offer-icon">
                  <CheckIcon />
                </div>
                <p>State of the Art Facilities</p>
              </li>
            </ul>
            <div className="offer-btn">
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("upcoming-events")
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                See Upcoming Events
              </a>
            </div>
          </div>
        </div>
        <div className="service-card-sm">
          <h2 className="black-text-clip">OUR SPECIALITIES</h2>
          <div className="service-card-sm-list">
            <Link to="/instruction" className="service-card-sm-item">
              <div className="service-card-sm-IMG">
                <img src={ICSM} alt="IC" />
              </div>
              <p className="black-text-clip">Instructional Classes</p>
              <ArrowIcon />
            </Link>
            <Link to="/field-days" className="service-card-sm-item">
              <div className="service-card-sm-IMG">
                <img src={FDSM} alt="IC" />
              </div>
              <p className="black-text-clip">Field days & Carnivals</p>
              <ArrowIcon />
            </Link>
            <Link to="/summer-camp" className="service-card-sm-item">
              <div className="service-card-sm-IMG">
                <img src={SCSM} alt="IC" />
              </div>
              <p className="black-text-clip">Summer Camp</p>
              <ArrowIcon />
            </Link>
            <Link to="/school-programs" className="service-card-sm-item">
              <div className="service-card-sm-IMG">
                <img src={SPSM} alt="IC" />
              </div>
              <p className="black-text-clip">School Programs</p>
              <ArrowIcon />
            </Link>
            <Link to="/after-school-programs" className="service-card-sm-item">
              <div className="service-card-sm-IMG">
                <img src={ASPSM} alt="IC" />
              </div>
              <p className="black-text-clip">After School Programs</p>
              <ArrowIcon />
            </Link>
            <Link to="/fundraising" className="service-card-sm-item">
              <div className="service-card-sm-IMG">
                <img src={FPSM} alt="IC" />
              </div>
              <p className="black-text-clip">Fundraising Program</p>
              <ArrowIcon />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OurServices;
